import React, { useState } from "react";

const services = [
  {
    title: "iOS Mobile App Development",
    paras: [
      "We build custom iOS applications for businesses that want to reach Apple users across the UAE.",
    ],
    listIntro: "Our iOS app development services include:",
    list: [
      "iPhone and iPad app development",
      "Swift and SwiftUI development",
      "Apple Pay integration",
      "Face ID and biometric features",
      "App Store submission support",
    ],
    outro: "We focus on creating iOS apps that feel fast, reliable, and natural for Apple users.",
  },
  {
    title: "Android App Development",
    paras: [
      "Android users represent a large part of the UAE mobile market. We create Android applications that perform smoothly across different smartphones and screen sizes.",
    ],
    listIntro: "Our Android development services include:",
    list: [
      "Custom Android applications",
      "Kotlin development",
      "API integration",
      "Device compatibility testing",
      "Performance optimization",
    ],
    outro: "We test apps on real devices to ensure a better experience for users.",
  },
  {
    title: "Cross-Platform App Development",
    paras: [
      "Need an app for both iOS and Android? Cross-platform development can help you launch faster while keeping development costs controlled.",
      "Using technologies like Flutter and React Native, we build applications that work across multiple platforms without compromising performance.",
    ],
    listIntro: "This approach is ideal for:",
    list: [
      "Startups launching an MVP",
      "Businesses testing new ideas",
      "Companies needing faster market delivery",
    ],
    outro: "",
  },
  {
    title: "Custom Mobile App Development",
    paras: [
      "Every business has different goals. We create custom mobile applications based on your workflow, customers, and industry requirements.",
    ],
    listIntro: "Our custom app development services include:",
    list: [
      "Business mobile apps",
      "Ecommerce applications",
      "Booking apps",
      "Customer portals",
      "Internal company apps",
      "On-demand applications",
    ],
    outro: "Instead of forcing your business into a ready-made solution, we build technology around your needs.",
  },
  {
    title: "UI/UX Design for Mobile Applications",
    paras: [
      "A good app is not only about features. It should also be simple and enjoyable to use.",
    ],
    listIntro: "uiux-link",
    list: [
      "User-friendly interfaces",
      "Wireframes and prototypes",
      "Customer-focused journeys",
      "Arabic RTL designs",
      "Modern mobile experiences",
    ],
    outro: "We design apps that help users complete tasks faster.",
  },
  {
    title: "Backend Development and API Integration",
    paras: ["A powerful mobile app needs a strong backend system."],
    listIntro: "We develop secure backend solutions for:",
    list: [
      "User management",
      "Databases",
      "Payment systems",
      "Third-party integrations",
      "Business automation",
    ],
    outro: "We also integrate popular payment solutions and business tools used by companies across the UAE.",
  },
  {
    title: "MVP App Development for Startups",
    paras: [
      "Launching a new idea? You do not always need a fully loaded app from day one.",
    ],
    listIntro: "Our MVP development services help startups:",
    list: [
      "Validate ideas",
      "Launch faster",
      "Test customer response",
      "Reduce initial development costs",
    ],
    outro: "We focus on building the features that matter most first.",
  },
  {
    title: "Mobile App Maintenance and Support",
    paras: ["App development does not end after launch."],
    listIntro: "We provide ongoing support including:",
    list: ["Bug fixes", "Security updates", "Performance improvements", "New features", "Platform updates"],
    outro: "Our goal is to help your app stay reliable as your business grows.",
  },
];

export default function Section4() {
  const [active, setActive] = useState(0);
  const current = services[active];

  return (
    <div className="w-full Section4 py-[35px]">
      <div className="container-1280 section4-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Our Mobile App Development Services in UAE
        </h2>

        <div className="flex flex-col md:flex-row gap-6 md:gap-8 mt-6">
          <div className="w-full md:w-[30%] flex md:flex-col overflow-x-auto md:overflow-visible gap-2 pb-2 md:pb-0">
            {services.map((service, index) => (
              <button
                key={service.title}
                onClick={() => setActive(index)}
                className={`text-left whitespace-nowrap md:whitespace-normal shrink-0 px-4 py-3 rounded-[6px] text-xs md:text-sm font-open font-bold transition-colors ${
                  active === index
                    ? "bg-[#cd2122] text-white"
                    : "bg-[#F5F5F5] text-[#535353] hover:bg-[#ececec]"
                }`}
              >
                {service.title}
              </button>
            ))}
          </div>

          <div className="w-full md:w-[70%] bg-white rounded-[8px] p-[6%] md:p-[3%] border border-[#EDEDED]">
            <h3 className="text-[19px] md:text-[23px] font-bold leading-[28px] text-[#cd2122] my-[0.4em]">
              {current.title}
            </h3>

            {current.paras.map((p, i) => (
              <p key={i} className="leading-[22px] text-sm md:text-base text-[#535353] mb-4 font-open">
                {p}
              </p>
            ))}

            {current.listIntro === "uiux-link" ? (
              <p className="leading-[22px] text-sm md:text-base text-[#151515] font-bold mb-3 font-open">
                Our{" "}
                <a
                  href="https://mean3.ae/ui-ux-design-services"
                  className="blue-link"
                >
                  UI/UX designers
                </a>{" "}
                create:
              </p>
            ) : (
              <p className="leading-[22px] text-sm md:text-base text-[#151515] font-bold mb-3 font-open">
                {current.listIntro}
              </p>
            )}

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 mb-4">
              {current.list.map((item) => (
                <li key={item} className="flex items-start text-sm md:text-base font-open text-[#535353]">
                  <span className="text-[#cd2122] text-lg leading-[20px] mr-2">•</span>
                  {item}
                </li>
              ))}
            </ul>

            {current.outro && (
              <p className="leading-[22px] text-sm md:text-base text-[#535353] font-open">
                {current.outro}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}